import React from 'react';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import Navbar from '../../components/Navbar/Navbar';
import './Contactus.scss';
import Footer from '../../sections/Footer/Footer';
import ContactForm from '../../components/ContactForm/ContactForm';
import SEO from '../../components/SEO/SEO';
import { useTranslation } from 'react-i18next';
import { MdPhone, MdEmail, MdLocationOn, MdPerson } from 'react-icons/md';

const Contactus = () => {
    const { t } = useTranslation();
    return (
        <>
            <SEO
                title="Kontakt & Termin | Zahnarztpraxis Roman Boretskyi Tönisvorst"
                description="Vereinbaren Sie online oder telefonisch einen Termin bei der Zahnarztpraxis Roman Boretskyi in Tönisvorst. Adresse, Öffnungszeiten und Kontaktformular."
                path="/kontakt"
            />
            <section className='section-bg section-common contact-section'>
                <Navbar />
                <SectionTitle 
                    title={t('contact.title')}
                    description={t('contact.description')}
                />
            </section>
            
            <section className='contact-content-area pt-100 pb-70'>
                <div className="container">
                    <div className="row">
                        {/* Contact Information */}
                        <div className="col-lg-6">
                            <div className="contact-info-card" data-aos="fade-up">
                                <h3>Kontaktinformationen</h3>
                                <div className="contact-info-list">
                                    <div className="contact-info-item">
                                        <div className="contact-icon">
                                            <MdPhone size={24} />
                                        </div>
                                        <div className="contact-text">
                                            <h4>{t('footer.phoneNumber')}</h4>
                                            <p><a href={`tel:${t('footer.phone')}`}>{t('footer.phone')}</a></p>
                                        </div>
                                    </div>
                                    <div className="contact-info-item">
                                        <div className="contact-icon">
                                            <MdEmail size={24} />
                                        </div>
                                        <div className="contact-text">
                                            <h4>E-Mail</h4>
                                            <p><a href="mailto:anmeldung@zahnarzt-st-toenis.de">anmeldung@zahnarzt-st-toenis.de</a></p>
                                        </div>
                                    </div>
                                    <div className="contact-info-item">
                                        <div className="contact-icon">
                                            <MdLocationOn size={24} />
                                        </div>
                                        <div className="contact-text">
                                            <h4>{t('footer.clinicAddress')}</h4>
                                            <p>{t('contact.address')}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Opening Hours */}
                        <div className="col-lg-6">
                            <div className="opening-hours-card" data-aos="fade-up" data-aos-delay="100">
                                <h3>{t('contact.openingHours')}</h3>
                                <div className="opening-hours-content">
                                    <div className="hours-section">
                                        <div className="hours-day">{t('openingHoursPopup.mondayThursday')}</div>
                                        <div className="hours-time">{t('openingHoursPopup.mondayThursdayHours1')}</div>
                                        <div className="hours-time">{t('openingHoursPopup.mondayThursdayHours2')}</div>
                                    </div>
                                    <div className="hours-section">
                                        <div className="hours-day">{t('openingHoursPopup.friday')}</div>
                                        <div className="hours-time">{t('openingHoursPopup.fridayHours')}</div>
                                    </div>
                                    <div className="hours-section">
                                        <div className="hours-day">{t('openingHoursPopup.saturday')}</div>
                                        <div className="hours-time">{t('openingHoursPopup.saturdayHours')}</div>
                                    </div>
                                </div>
                                <div className="acute-hours-section">
                                    <div className="acute-title">{t('openingHoursPopup.acuteTitle')}</div>
                                    <div className="acute-time">{t('openingHoursPopup.acuteHours')}</div>
                                </div>
                                <div className="walk-in-notice">
                                    <p>{t('contact.walkInNote')}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Appointment Information */}
                    <div className="row mt-5">
                        <div className="col-lg-12">
                            <div className="appointment-info-card" data-aos="fade-up" data-aos-delay="200">
                                <h3>{t('contact.appointmentTitle')}</h3>
                                <p className="appointment-intro">{t('contact.appointmentDescription')}</p>
                                
                                <div className="appointment-methods">
                                    <div className="appointment-method">
                                        <div className="method-icon">
                                            <MdEmail size={28} />
                                        </div>
                                        <div className="method-content">
                                            <h4>{t('contact.appointmentEmail')}</h4>
                                            <p>{t('contact.appointmentEmailText')}</p>
                                        </div>
                                    </div>
                                    
                                    <div className="appointment-method">
                                        <div className="method-icon">
                                            <MdPhone size={28} />
                                        </div>
                                        <div className="method-content">
                                            <h4>{t('contact.appointmentPhone')}</h4>
                                            <p>{t('contact.appointmentPhoneText')}</p>
                                        </div>
                                    </div>
                                    
                                    <div className="appointment-method">
                                        <div className="method-icon">
                                            <MdPerson size={28} />
                                        </div>
                                        <div className="method-content">
                                            <h4>{t('contact.appointmentPersonal')}</h4>
                                            <p>{t('contact.appointmentPersonalText')}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Contact Form */}
                    <div className="row mt-5">
                        <div className="col-lg-12">
                            <div className="contact-form-card" data-aos="fade-up" data-aos-delay="300">
                                <h3>{t('contactForm.sectionTitle') || 'Kontaktformular'}</h3>
                                <p className="form-intro">{t('contactForm.sectionDescription') || 'Füllen Sie das Formular aus und wir melden uns schnellstmöglich bei Ihnen.'}</p>
                                <ContactForm />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default Contactus;